import React from 'react';
import { Link } from 'react-router-dom';
import { bulletin } from '../data/changelog';
import { BRAND } from '../data/brand';
import { formatReleased } from '../utils/format';
import { PageHeader } from '../components/PageHeader';
const KIND_STYLE: Record<string, string> = {
  Data: 'text-human',
  Feature: 'text-machine',
  Correction: 'text-signal',
  Method: 'text-live'
};
export function Changelog() {
  return <>
      <PageHeader title="Census Bulletin" lede={`Every data update to ${BRAND.domain}, dated, newest first. Corrections sent through “Challenge this number” are confirmed here.`} data-id="element-976" data-mp="25r4nuhfrql8e" />
      <section className="mx-auto max-w-[1000px] px-5 pt-10 md:px-8" data-id="element-977" data-mp="1w0a0taup7hlw">
        <ol className="relative border-l border-line" data-id="element-978" data-mp="1r3ji0frie7ws">
          {bulletin.map(e => <li key={e.id} id={e.id} className="relative scroll-mt-32 pb-10 pl-8 last:pb-0" data-id="element-979" data-mp="2oifc0qu40jwl">
              <span className="absolute -left-[5px] top-2 h-[9px] w-[9px] rounded-full border border-faint bg-bg" aria-hidden="true" data-id="element-980" data-mp="2jqx9hycfub9i" />
              <p className="flex flex-wrap items-baseline gap-3 font-mono text-[12px]" data-id="element-981" data-mp="qojyvc03sc6y">
                <time dateTime={e.date} className="text-muted" data-id="element-982" data-mp="vltkegkdg3pi">
                  {formatReleased(e.date)}
                </time>
                <span className={KIND_STYLE[e.kind]} data-id="element-983" data-mp="gw4hafspxpml">{e.kind}</span>
              </p>
              <h2 className="mt-1 font-serif text-xl text-ink" data-id="element-984" data-mp="lvqpubxlqhp2">{e.title}</h2>
              <p className="mt-2 max-w-2xl text-[14px] leading-relaxed text-ink/85" data-id="element-985" data-mp="7whb7gp1nvn7">{e.summary}</p>
              <p className="mt-3 flex flex-wrap gap-x-4 gap-y-1 text-[13px]" data-id="element-986" data-mp="c06wnxaf9x40">
                <span className="text-faint" data-id="element-987" data-mp="3u5a6fvbc2xar">Affects</span>
                {e.pages.map(p => <Link key={p.to} to={p.to} className="text-muted underline decoration-line underline-offset-2 hover:text-machine" data-id="element-988" data-mp="2xxq1ii9ynvw">
                    {p.label}
                  </Link>)}
              </p>
            </li>)}
        </ol>
      </section>
    </>;
}